import React, { Component } from 'react'
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineSearch } from "react-icons/ai";
import "../../css/general-style.css"
import '../../css/table-responsive.css'
import "../../css/inventory-style.css"
import '../../css/reports-v2.css'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithData } from '../../services/CABE';
import { DeleteCharactersNotAccepted, ItemDesc, ItemDescV2, MonthInLetters, NumberFormat, OrderArray } from '../../functions/generalFunctions';
import { getIndexElement } from '../../functions/searchInObject'
import { pricesFormat } from '../../functions/pricesFormat';
import { v4 as uuidv4 } from 'uuid';
import LoadingWindow from '../../components/LoadingWindow';
import ExcelDocument from '../../components/ExcelDocument';
import { getDataSet, getDataSetSales, getDataSetSales2 } from '../../functions/generateDataSetExcel';
import ModalOrders from '../../components/ModalComponent';
import { DateFormatMAS90, getDateFromReports, OrderArrayByDateGenericLines } from '../../functions/dateFormat';
import { confirmCloseAlert } from '../../functions/alerts';
import { Menu } from '../../components/Menu/Menu';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

/* ---- Chart options ---- */
const monthlyChartOptions = {
    responsive: true,
    plugins: {
        legend: { display: false },
        tooltip: {
            callbacks: {
                label: (ctx) =>
                    ' $' + Number(ctx.raw).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            },
        },
    },
    scales: {
        y: {
            ticks: {
                callback: (v) => '$' + Number(v).toLocaleString('en-US', { notation: 'compact' }),
            },
            grid: { color: 'rgba(0,0,0,0.05)' },
        },
        x: { grid: { display: false } },
    },
};

const topItemsChartOptions = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
        legend: { display: false },
        tooltip: {
            callbacks: {
                label: (ctx) =>
                    ' $' + Number(ctx.raw).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
            },
        },
    },
    scales: {
        x: {
            ticks: {
                callback: (v) => '$' + Number(v).toLocaleString('en-US', { notation: 'compact' }),
            },
            grid: { color: 'rgba(0,0,0,0.05)' },
        },
        y: { grid: { display: false } },
    },
};

export default class Sales extends Component {
    constructor(props) {
        super(props)
        this.BarGraph1 = React.createRef()
        this.ModalLoading = React.createRef();
    }

    state = {
        HeaderTable: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        HeaderTable2: {
            Row1: [],
            Row2: [],
            Row3: []
        },
        BodyCustomer: [],
        BodyFilterCustomer: [],
        Body: [],
        BodyFilter: [],
        AllInformation: [],
        Totals: [],
        SalesTotal: 0,
        SalesTotalMonthly: [],
        showModal1: false,
        currentItem: {
            ItemCode: '',
            ItemCodeDesc: '',
            ProductLine: '',
            itemURL: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        currentCustomer: {
            CustomerNo: '',
            CustomerName: '',
            totalShorts: 0,
            totalQuantityShipped: 0,
            totalQuantityOrdered: 0,
            totalShort: 0
        },
        AllNoProccessInformation: [],
        ShortDetail: [],
        CustomerDetail: [],
        ShortDetailWithTotal: [],
        flag: true,
        Mode: 1,
        CustomerList: [],
    }

    /* ------------------------------------------------------------------ */
    /*  Data loading & processing (unchanged)                               */
    /* ------------------------------------------------------------------ */

    TableHeader(splitStartDate, splitEndDate) {
        let years = [{ year: '', span: 6 }]
        let years2 = [{ year: '', span: 9 }]
        let months = []
        let General = [{ year: '', month: '', title: ['   No   ', 'Item Code', 'Product Line', 'Description', 'Category', 'Subcategory'] }]
        let General2 = [{ year: '', month: '', title: ['   No   ', 'Customer No', 'Customer Name', 'Address', 'City', 'State', 'Zip Code'] }]

        for (let a = Number(splitStartDate[0]); a <= Number(splitEndDate[0]); a++) {
            if (a === Number(splitStartDate[0]) && a === Number(splitEndDate[0])) {
                var cont1 = 0
                for (let b = Number(splitStartDate[1]); b <= Number(splitEndDate[1]); b++) {
                    cont1++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                }
                const temp = { year: String(a), span: cont1 * 3 }
                years.push(temp)
                years2.push(temp)
                break
            } else if (a === Number(splitStartDate[0])) {
                var cont2 = 0
                for (let b = Number(splitStartDate[1]); b <= 12; b++) {
                    cont2++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                }
                const temp = { year: String(a), span: cont2 * 3 }
                years.push(temp)
                years2.push(temp)
            } else if (a === Number(splitEndDate[0])) {
                var cont3 = 0
                for (let b = 1; b <= Number(splitEndDate[1]); b++) {
                    cont3++
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                }
                const temp = { year: String(a), span: cont3 * 3 }
                years.push(temp)
                years2.push(temp)
            } else {
                for (let b = 1; b <= 12; b++) {
                    months.push({ year: String(a), num: b, month: MonthInLetters(b) })
                    General = General.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                    General2 = General2.concat([{ year: String(a), month: b < 10 ? '0' + String(b) : String(b), title: ['Sales', '', 'Sales ($)'] }])
                }
                const temp = { year: String(a), span: 12 * 3 }
                years.push(temp)
                years2.push(temp)
            }
        }

        this.setState({
            HeaderTable: { Row1: years, Row2: months, Row3: General },
            HeaderTable2: { Row1: years2, Row2: months, Row3: General2 }
        })
    }

    clearAll() {
        this.setState({
            HeaderTable: { Row1: [], Row2: [], Row3: [] },
            Body: [],
            BodyFilter: [],
            AllInformation: [],
            Totals: [],
            currentItem: { ItemCode: '', ItemCodeDesc: '', ProductLine: '', itemURL: '' },
            AllNoProccessInformation: [],
            ShortDetail: [],
        })
    }

    async getCustomerData() {
        const data = { SalespersonNo: '0000' }
        const response = await getInformationWithData('/customer/getList', data)
        const customers = response.data
        this.setState({ CustomerList: customers });
        return customers;
    }

    async addCustomerData(data) {
        const customers = await this.getCustomerData()
        const dataWCustomer = data.map(item => {
            const customer = customers.find(c => c.customerNo === item.CustomerNo);
            if (customer) {
                return {
                    ...item,
                    AddressLine1: customer.addressLine1,
                    City: customer.city,
                    State: customer.state,
                    ZipCode: customer.zipCode
                };
            }
            return item;
        });
        return dataWCustomer;
    }

    async getShorts() {
        this.ModalLoading.current.showState(true);
        this.clearAll()
        var date1 = document.getElementById('startSalesFilterDate').value
        var date2 = document.getElementById('endSalesFilterDate').value
        const splitStartDate = date1.split('-')
        const splitEndDate = date2.split('-')
        if (splitStartDate.length === 3 && splitEndDate.length === 3) {
            this.TableHeader(splitStartDate, splitEndDate)
            const data = {
                Start: date1,
                End: date2,
                idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId'))
            }
            // Get totals for KPIs and charts
            await this.getSaleTotal(date1, date2);

            let result = await getInformationWithData('/invoice/report/SalesV2', data)
            const parsedNumbers = (obj) => ({
                ...obj,
                UnitPrice: Number(obj.UnitPrice),
                UnitCost: Number(obj.UnitCost),
                QuantityOrdered: Number(obj.QuantityOrdered),
                QuantityShipped: Number(obj.QuantityShipped),
                shorts: Number(obj.shorts),
                SalesOrderNo: obj.SalesOrderNo ? obj.SalesOrderNo : ''
            })

            const updatedParsedData = result.data.map(parsedNumbers);
            result.data = updatedParsedData;

            let temporal = []
            let customer = []
            if (result.status.code === 1) {
                const AllInformationWCustomer = await this.addCustomerData(result.data);
                this.setState({ AllInformation: AllInformationWCustomer })

                for (const item of AllInformationWCustomer) {
                    const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
                    const index2 = getIndexElement(customer, 'CustomerNo', item.CustomerNo)
                    const splitDate = item.InvoiceDate ? item.InvoiceDate.split('-') : []

                    if (index === -1 && splitDate.length === 3) {
                        const json = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            Category: item.Category,
                            Subcategory: item.Subcategory,
                            Detail: []
                        }
                        const year = { year: String(splitDate[0]), Months: [] }
                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: item.shorts,
                            QuantityShipped: Number(item.QuantityShipped),
                            PurchaseCost: item.UnitCost,
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        temporal.push(json)
                    } else if (splitDate.length === 3) {
                        const element = temporal[index]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = { year: String(splitDate[0]), Months: [] }
                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: item.shorts,
                                QuantityShipped: Number(item.QuantityShipped),
                                PurchaseCost: item.UnitCost,
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: item.shorts,
                                    QuantityShipped: Number(item.QuantityShipped),
                                    PurchaseCost: item.UnitCost,
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                temporal[index] = element
                            } else {
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += item.shorts
                                element3.QuantityShipped += item.QuantityShipped
                                element3.PurchaseCost += item.UnitCost
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                temporal[index] = element
                            }
                        }
                    }

                    if (index2 === -1 && splitDate.length === 3) {
                        const json = {
                            CustomerNo: item.CustomerNo,
                            CustomerName: item.BillToName,
                            AddressLine1: item.AddressLine1,
                            City: item.City,
                            State: item.State,
                            ZipCode: item.ZipCode,
                            Detail: []
                        }
                        const year = { year: String(splitDate[0]), Months: [] }
                        const month = {
                            month: String(splitDate[1]),
                            dolar: '$',
                            shorts: item.shorts,
                            QuantityShipped: Number(item.QuantityShipped),
                            PurchaseCost: item.UnitCost,
                        }
                        year.Months.push(month)
                        json.Detail.push(year)
                        customer.push(json)
                    } else if (splitDate.length === 3) {
                        const element = customer[index2]
                        const indexYear = getIndexElement(element.Detail, 'year', String(splitDate[0]))
                        if (indexYear === -1) {
                            const year2 = { year: String(splitDate[0]), Months: [] }
                            const month2 = {
                                month: String(splitDate[1]),
                                dolar: '$',
                                shorts: item.shorts,
                                QuantityShipped: Number(item.QuantityShipped),
                                PurchaseCost: item.UnitCost,
                            }
                            year2.Months.push(month2)
                            element.Detail.push(year2)
                        } else {
                            const element2 = element.Detail[indexYear]
                            const indexMonth = getIndexElement(element2.Months, 'month', String(splitDate[1]))
                            if (indexMonth === -1) {
                                const month3 = {
                                    month: String(splitDate[1]),
                                    dolar: '$',
                                    shorts: item.shorts,
                                    QuantityShipped: Number(item.QuantityShipped),
                                    PurchaseCost: item.UnitCost,
                                }
                                element2.Months.push(month3)
                                element.Detail[indexYear] = element2
                                customer[index2] = element
                            } else {
                                const element3 = element2.Months[indexMonth]
                                element3.shorts += item.shorts
                                element3.QuantityShipped += item.QuantityShipped
                                element3.PurchaseCost += item.UnitCost
                                element2.Months[indexMonth] = element3
                                element.Detail[indexYear] = element2
                                customer[index2] = element
                            }
                        }
                    }
                }

                for (const month of this.state.HeaderTable.Row2) {
                    for (const item of temporal) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-', QuantityShipped: 0.00, dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal2 = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal2.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-', QuantityShipped: 0.00, dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }
                                temporal2.Months.push(add2)
                                item.Detail[indexyear] = temporal2
                            }
                        }
                    }

                    for (const item of customer) {
                        const indexyear = getIndexElement(item.Detail, 'year', month.year)
                        if (indexyear === -1) {
                            const add = {
                                year: month.year,
                                Months: [{
                                    PurchaseCost: '-', QuantityShipped: 0.00, dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }]
                            }
                            item.Detail.push(add)
                        } else {
                            const temporal2 = item.Detail[indexyear]
                            const indexmonth = getIndexElement(temporal2.Months, 'month', String(month.num).length === 1 ? "0" + String(month.num) : String(month.num))
                            if (indexmonth === -1) {
                                const add2 = {
                                    PurchaseCost: '-', QuantityShipped: 0.00, dolar: "$",
                                    month: String(month.num).length === 1 ? "0" + String(month.num) : String(month.num),
                                    shorts: 0.00,
                                }
                                temporal2.Months.push(add2)
                                item.Detail[indexyear] = temporal2
                            }
                        }
                    }
                }

                temporal = this.Order(temporal, 'ItemCode', true)
                customer = this.Order(customer, 'CustomerNo', true)
                const customers = this.state.CustomerList;
                customer = customer.map(item => {
                    const c = customers.find(c => c.CustomerNo === item.CustomerNo);
                    if (c) {
                        return { ...item, Address: c.AddressLine1 || '', City: c.City || '', State: c.State || '', ZipCode: c.ZipCode || '' };
                    }
                    return item;
                });

                temporal = await ItemDescV2(temporal, 'ItemCodeDesc', 'ItemCode')
                for (const item of temporal) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }
                for (const item of customer) {
                    for (const detail of item.Detail) {
                        detail.Months = this.Order(detail.Months, 'month', true)
                    }
                    item.Detail = this.Order(item.Detail, 'year', true)
                }
                await this.setState({ BodyCustomer: customer, BodyFilterCustomer: customer, Body: temporal, BodyFilter: temporal, Totals: this.getTotals(temporal), AllNoProccessInformation: result.data })
            }
        } else {
            confirmCloseAlert('incorrect', 'Both dates must be established\n to make the report!')
        }
        this.ModalLoading.current.showState(false);
    }

    async getSaleTotal(Start, End) {
        const data = { Start, End }
        const response = await getInformationWithData('/invoice/report/getSalesTotal', data)
        const responseData = response && response.data ? response.data : {}
        const total = Number(
            responseData.total != null ? responseData.total :
            responseData.Total != null ? responseData.Total :
            responseData.totalRevenue != null ? responseData.totalRevenue :
            responseData.TotalRevenue != null ? responseData.TotalRevenue :
            responseData.NonTaxableSalesAmt != null ? responseData.NonTaxableSalesAmt :
            0
        )
        let monthlyTotals = []
        const rawMonthly = responseData.monthly != null ? responseData.monthly :
            responseData.Monthly != null ? responseData.Monthly :
            responseData.Months != null ? responseData.Months :
            responseData.data
        if (Array.isArray(rawMonthly)) {
            monthlyTotals = rawMonthly
        }
        await this.setState({
            SalesTotal: Number.isFinite(total) ? total : 0,
            SalesTotalMonthly: monthlyTotals,
        })
    }
    /* ------------------------------------------------------------------ */
    /*  Search & sort helpers (unchanged)                                   */
    /* ------------------------------------------------------------------ */

    contains = (parametro, busqueda) => {
        if (!parametro) return false;
        return parametro.toString().toLowerCase().includes(busqueda.toLowerCase());
    }

    searchShorts = e => {
        const search = e.target.value.toLowerCase();
        const { Body } = this.state;
        const orders = Body.filter(item =>
            this.contains(item.ItemCode, search) ||
            this.contains(item.ProductLine, search) ||
            this.contains(item.ItemCodeDesc, search)
        );
        this.setState({ BodyFilter: orders, Totals: this.getTotals(orders) });
    }

    searchShorts2 = e => {
        const search = e.target.value;
        const { BodyCustomer } = this.state;
        const orders = BodyCustomer.filter(item =>
            this.contains(item.CustomerNo, search) ||
            this.contains(item.CustomerName, search)
        );
        this.setState({ BodyFilterCustomer: orders, Totals: this.getTotals(orders) });
    }

    getTotals(temporal) {
        let totals = []
        let flag = true
        let count = 0
        for (const item of temporal) {
            for (const detail of item.Detail) {
                for (let a = 0; a < detail.Months.length; a++) {
                    if (flag) {
                        totals.push(detail.Months[a].QuantityShipped === '-' ? 0 : Number(detail.Months[a].QuantityShipped))
                        totals.push('$')
                        totals.push(detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts))
                    } else {
                        totals[count] += detail.Months[a].QuantityShipped === '-' ? 0 : Number(detail.Months[a].QuantityShipped)
                        count += 2
                        totals[count] += detail.Months[a].shorts === '-' ? 0 : Number(detail.Months[a].shorts)
                        count += 1
                    }
                }
            }
            flag = false
            count = 0
        }
        for (let num = 0; num < totals.length; num++) {
            if (totals[num] !== '$') {
                totals[num] = NumberFormat(pricesFormat(totals[num]))
            }
        }
        return totals
    }

    Order(arreglo, llave, bandera) {
        const l = arreglo.length;
        if (bandera) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] > arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if (arreglo[j][llave] < arreglo[j + 1][llave]) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }
        return arreglo;
    }

    handleModalOpen = (modal) => { this.setState({ [modal]: true }) }
    handleModalClose = (modal) => { this.setState({ [modal]: false }) }

    clearOnlyShortDetail() {
        this.setState({
            currentItem: { ItemCode: '', ItemCodeDesc: '', ProductLine: '', itemURL: '', totalShorts: 0, totalQuantityShipped: 0, totalQuantityOrdered: 0, totalShort: 0 },
            ShortDetail: [],
            currentCustomer: { CustomerNo: '', CustomerName: '', totalShorts: 0, totalQuantityShipped: 0, totalQuantityOrdered: 0, totalShort: 0 },
            CustomerDetail: [],
        })
    }

    async DetailofShort(itemCode) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentItem
        temporal.ItemCode = itemCode.ItemCode
        temporal.ItemCodeDesc = itemCode.ItemCodeDesc
        temporal.ProductLine = itemCode.ProductLine
        temporal.Category = itemCode.Category
        temporal.Subcategory = itemCode.Subcategory

        let SpecificDetail = []
        var total = 0, totalShipped = 0, totalOrdered = 0

        for (const item of this.state.AllNoProccessInformation) {
            if (item.ItemCode === itemCode.ItemCode) {
                total += item.shorts
                totalShipped += item.QuantityShipped
                totalOrdered += item.QuantityOrdered
                item.TotalShort = item.shorts
                item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                item.TotalShortD = '$' + pricesFormat(item.shorts)
                SpecificDetail.push(item)
            }
        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        SpecificDetail.push()
        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')

        const data = { idCompany: Number(getValueCookie('CompanyId')), ItemCode: itemCode.ItemCode }
        const resultImg = await getInformationWithData('/Items/get/Img', data)
        if (resultImg.status.code === 1 && resultImg.data.itemURLImage) {
            temporal.itemURL = resultImg.data.itemURLImage !== '' ? `${resultImg.data.itemURLImage}?${new Date().getTime()}` : ''
        } else {
            temporal.itemURL = ''
        }

        await this.setState({ ShortDetail: SpecificDetail, currentItem: temporal })
        var totalRow = { InvoiceDate: 'TOTAL', QuantityShipped: totalShipped, QuantityOrdered: totalOrdered, TotalShortD: '$' + pricesFormat(total) }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }

    async DetailbyCustomer(info) {
        this.clearOnlyShortDetail()
        const temporal = this.state.currentCustomer
        temporal.CustomerNo = info.CustomerNo
        temporal.CustomerName = info.CustomerName

        let SpecificDetail = []
        var total = 0, totalShipped = 0, totalOrdered = 0

        for (const item of this.state.AllNoProccessInformation) {
            if (item.CustomerNo === info.CustomerNo) {
                total += item.shorts
                totalShipped += item.QuantityShipped
                totalOrdered += item.QuantityOrdered
                item.TotalShort = item.shorts
                item.UnitCostD = '$' + pricesFormat(item.UnitCost)
                item.UnitPriceD = '$' + pricesFormat(item.UnitPrice)
                item.TotalShortD = '$' + pricesFormat(item.shorts)
                SpecificDetail.push(item)
            }
        }
        temporal.totalShorts = total
        temporal.totalQuantityShipped = totalShipped
        temporal.totalQuantityOrdered = totalOrdered
        SpecificDetail.push()
        SpecificDetail = OrderArrayByDateGenericLines(SpecificDetail, 'InvoiceDate')

        await this.setState({ CustomerDetail: SpecificDetail, currentCustomer: temporal })
        var totalRow = { InvoiceDate: 'TOTAL', QuantityShipped: totalShipped, QuantityOrdered: totalOrdered, TotalShortD: '$' + pricesFormat(total) }
        var copySpecificDetail = JSON.parse(JSON.stringify(SpecificDetail))
        copySpecificDetail.push(totalRow)
        await this.setState({ ShortDetailWithTotal: copySpecificDetail })
        await this.handleModalOpen('showModal1')
    }

    async OrderPriceMargins(option, pos) {
        var temporal = this.state.BodyFilter
        switch (option) {
            case "Item Code":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Product Line":
                temporal = OrderArray(temporal, "ProductLine", this.state.flag)
                this.setState({ BodyFilter: temporal, flag: !this.state.flag })
                break;
            case "Sales":
                let t1 = await this.orderShorts(temporal, pos, "QuantityShipped")
                await this.setState({ BodyFilter: t1, flag: !this.state.flag })
                break;
            case "Sales ($)":
                let t2 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilter: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    async OrderPriceMargins2(option, pos) {
        var temporal = this.state.BodyFilterCustomer
        switch (option) {
            case "Customer No":
                temporal = OrderArray(temporal, "CustomerNo", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Customer Name":
                temporal = OrderArray(temporal, "CustomerName", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Address":
                temporal = OrderArray(temporal, "AddressLine1", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "City":
                temporal = OrderArray(temporal, "City", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "State":
                temporal = OrderArray(temporal, "State", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Zip Code":
                temporal = OrderArray(temporal, "ZipCode", this.state.flag)
                this.setState({ BodyFilterCustomer: temporal, flag: !this.state.flag })
                break;
            case "Sales":
                let t1 = await this.orderShorts(temporal, pos, "QuantityShipped")
                await this.setState({ BodyFilterCustomer: t1, flag: !this.state.flag })
                break;
            case "Sales ($)":
                let t2 = await this.orderShorts(temporal, pos, "shorts")
                await this.setState({ BodyFilterCustomer: t2, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    async orderShorts(array, conditions, key) {
        const l = array.length
        for (let i = 0; i < l; i++) {
            for (let j = 0; j < l - 1 - i; j++) {
                const pos1 = await getIndexElement(array[j].Detail, 'year', conditions.year)
                const pos2 = await getIndexElement(array[j].Detail[pos1].Months, 'month', conditions.month)
                const pos3 = await getIndexElement(array[j + 1].Detail, 'year', conditions.year)
                const pos4 = await getIndexElement(array[j + 1].Detail[pos3].Months, 'month', conditions.month)
                const m = array[j].Detail[pos1].Months[pos2][key] === '-' ? 0 : Number(array[j].Detail[pos1].Months[pos2][key])
                const n = array[j + 1].Detail[pos3].Months[pos4][key] === '-' ? 0 : Number(array[j + 1].Detail[pos3].Months[pos4][key])
                if (this.state.flag) {
                    if (m > n) [array[j], array[j + 1]] = [array[j + 1], array[j]];
                } else {
                    if (m < n) [array[j], array[j + 1]] = [array[j + 1], array[j]];
                }
            }
        }
        return array
    }

    /* ------------------------------------------------------------------ */
    /*  KPI & chart data helpers                                            */
    /* ------------------------------------------------------------------ */

    getKPIs() {
        const data = this.state.AllNoProccessInformation;
        if (!data.length) return null;
        const totalRevenue = Number.isFinite(this.state.SalesTotal)
            ? this.state.SalesTotal
            : data.reduce((s, r) => s + r.shorts, 0);
        const totalUnits   = data.reduce((s, r) => s + r.QuantityShipped, 0);
        const uniqueItems  = new Set(data.map(r => r.ItemCode)).size;
        const totalCost    = data.reduce((s, r) => s + (r.UnitCost * r.QuantityShipped), 0);
        const avgMargin    = totalRevenue > 0 ? ((totalRevenue - totalCost) / totalRevenue * 100) : 0;
        return { totalRevenue, totalUnits, uniqueItems, avgMargin };
    }

    getMonthlyChartData() {
        const monthlyTotals = this.state.SalesTotalMonthly;
        if (Array.isArray(monthlyTotals) && monthlyTotals.length) {
            const labels = []
            const values = []
            for (const item of monthlyTotals) {
                let label = ''
                if (item.month && item.year) {
                    label = MonthInLetters(Number(item.month)) + ' ' + item.year
                } else if (item.Month && item.Year) {
                    label = MonthInLetters(Number(item.Month)) + ' ' + item.Year
                } else if (item.date || item.InvoiceDate) {
                    const dateStr = item.date || item.InvoiceDate
                    const parts = String(dateStr).split('-')
                    if (parts.length >= 2) {
                        label = MonthInLetters(Number(parts[1])) + ' ' + parts[0]
                    }
                } else if (item.label) {
                    label = item.label
                } else if (item.Label) {
                    label = item.Label
                }

                const value = Number(
                    item.total != null ? item.total :
                    item.Total != null ? item.Total :
                    item.totalRevenue != null ? item.totalRevenue :
                    item.TotalRevenue != null ? item.TotalRevenue :
                    item.amount != null ? item.amount :
                    item.Amount != null ? item.Amount :
                    item.NonTaxableSalesAmt != null ? item.NonTaxableSalesAmt :
                    item.value != null ? item.value :
                    item.Value != null ? item.Value :
                    0
                )
                if (label) {
                    labels.push(label)
                    values.push(value)
                }
            }
            return {
                labels,
                datasets: [{
                    label: 'Revenue',
                    data: values,
                    backgroundColor: 'rgba(37, 99, 235, 0.82)',
                    hoverBackgroundColor: 'rgba(29, 78, 216, 0.92)',
                    borderRadius: 5,
                }],
            }
        }

        const data = this.state.AllNoProccessInformation;
        const map = {};
        for (const row of data) {
            if (!row.InvoiceDate) continue;
            const parts = row.InvoiceDate.split('-');
            if (parts.length < 2) continue;
            const key = `${parts[0]}-${parts[1]}`;
            map[key] = (map[key] || 0) + row.shorts;
        }
        const sorted = Object.keys(map).sort();
        return {
            labels: sorted.map(k => {
                const [y, m] = k.split('-');
                return MonthInLetters(Number(m)) + ' ' + y;
            }),
            datasets: [{
                label: 'Revenue',
                data: sorted.map(k => map[k]),
                backgroundColor: 'rgba(37, 99, 235, 0.82)',
                hoverBackgroundColor: 'rgba(29, 78, 216, 0.92)',
                borderRadius: 5,
            }],
        };
    }

    getTopItemsChartData() {
        const data = this.state.AllNoProccessInformation;
        const map = {};
        for (const row of data) {
            if (!row.ItemCode) continue;
            if (!map[row.ItemCode]) {
                map[row.ItemCode] = {
                    label: row.ItemCode,
                    value: 0,
                };
            }
            map[row.ItemCode].value += row.shorts;
        }
        const palette = [
            'rgba(37,99,235,0.82)', 'rgba(16,185,129,0.82)', 'rgba(245,158,11,0.82)',
            'rgba(139,92,246,0.82)', 'rgba(239,68,68,0.82)', 'rgba(14,165,233,0.82)',
            'rgba(234,179,8,0.82)', 'rgba(168,85,247,0.82)', 'rgba(34,197,94,0.82)',
            'rgba(249,115,22,0.82)',
        ];
        const sorted = Object.values(map).sort((a, b) => b.value - a.value).slice(0, 10);
        return {
            labels: sorted.map(i => i.label),
            datasets: [{
                label: 'Revenue ($)',
                data: sorted.map(i => i.value),
                backgroundColor: sorted.map((_, idx) => palette[idx % palette.length]),
                borderRadius: 4,
            }],
        };
    }

    /* ------------------------------------------------------------------ */
    /*  Render                                                               */
    /* ------------------------------------------------------------------ */

    render() {
        const hasData = this.state.AllNoProccessInformation.length > 0;
        const kpis = hasData ? this.getKPIs() : null;
        const { Mode } = this.state;

        return (
            <div className="rpt-page">
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* ── Page header ── */}
                <div className="rpt-page-header">
                    <h1 className="rpt-page-title">Sales Report</h1>
                    <p className="rpt-page-subtitle">Analyze sales by item or customer across any date range.</p>
                </div>

                {/* ── Controls card ── */}
                <div className="rpt-card rpt-controls">
                    <div className="row g-3 align-items-end">
                        <div className="col-sm-12 col-md-3">
                            <label className="rpt-label" htmlFor="startSalesFilterDate">Start Date</label>
                            <input className="rpt-input" id="startSalesFilterDate" type="date" />
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <label className="rpt-label" htmlFor="endSalesFilterDate">End Date</label>
                            <input className="rpt-input" id="endSalesFilterDate" type="date" />
                        </div>
                        <div className="col-sm-12 col-md-3">
                            <button onClick={() => this.getShorts()} className="rpt-btn-primary w-100">
                                <AiOutlineReload /> Load Data
                            </button>
                        </div>
                        {hasData && (
                            <div className="col-sm-12 col-md-3 d-flex justify-content-end">
                                {Mode === 1 ? (
                                    <ExcelDocument
                                        archname={'Sales ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                        sheetname2={['Sales Detail ' + getValueCookie('Company')]}
                                        sheetname={'Sales ' + getValueCookie('Company')}
                                        data={getDataSetSales(this.state.HeaderTable.Row1, this.state.HeaderTable.Row2, this.state.HeaderTable.Row3, this.state.Body, this.state.Totals)}
                                        data2={[getDataSet(this.state.AllInformation,
                                            ['Item Code', 'Product Line', 'Description', 'Sales Order No', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Category', 'Subcategory', 'Unit Price ($)', 'Unit Cost', 'Price Margin', 'Total Sales ($)'],
                                            ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'SalesOrderNo', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'Category', 'Subcategory', 'UnitPrice', 'UnitCost', 'PriceMargin', 'shorts']
                                        )]}
                                    />
                                ) : (
                                    <ExcelDocument
                                        archname={'Sales ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                        sheetname2={['Sales Detail ' + getValueCookie('Company')]}
                                        sheetname={'Sales ' + getValueCookie('Company')}
                                        data={getDataSetSales2(this.state.HeaderTable2.Row1, this.state.HeaderTable2.Row2, this.state.HeaderTable2.Row3, this.state.BodyCustomer, this.state.Totals)}
                                        data2={[getDataSet(this.state.AllInformation,
                                            ['Item Code', 'Product Line', 'Description', 'Sales Order No', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Price ($)', 'Total Sales ($)', 'Address', 'City', 'State', 'Zip Code'],
                                            ['ItemCode', 'ProductLineDesc', 'ItemCodeDesc', 'SalesOrderNo', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPrice', 'shorts', 'AddressLine1', 'City', 'State', 'ZipCode']
                                        )]}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* ── KPI row ── */}
                {hasData && kpis && (
                    <div className="rpt-kpi-row">
                        <div className="row g-3">
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-blue">
                                    <div className="rpt-kpi-label">Total Revenue</div>
                                    <div className="rpt-kpi-value">${NumberFormat(pricesFormat(kpis.totalRevenue))}</div>
                                    <div className="rpt-kpi-sub">Period total</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-green">
                                    <div className="rpt-kpi-label">Units Shipped</div>
                                    <div className="rpt-kpi-value">{Math.round(kpis.totalUnits).toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">Total units</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-purple">
                                    <div className="rpt-kpi-label">Unique Items</div>
                                    <div className="rpt-kpi-value">{kpis.uniqueItems.toLocaleString('en-US')}</div>
                                    <div className="rpt-kpi-sub">Distinct SKUs</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3">
                                <div className="rpt-kpi-card rpt-kpi-amber">
                                    <div className="rpt-kpi-label">Avg Margin</div>
                                    <div className="rpt-kpi-value">{pricesFormat(kpis.avgMargin)}%</div>
                                    <div className="rpt-kpi-sub">Weighted avg</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ── Charts row ── */}
                {hasData && (
                    <div className="rpt-charts-row">
                        <div className="row g-3">
                            <div className="col-md-8">
                                <div className="rpt-chart-card">
                                    <div className="rpt-card-title">Revenue by Month</div>
                                    <Bar data={this.getMonthlyChartData()} options={monthlyChartOptions} />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="rpt-chart-card">
                                    <div className="rpt-card-title">Top 10 Items by Revenue</div>
                                    <Bar data={this.getTopItemsChartData()} options={topItemsChartOptions} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ── Data table card ── */}
                {hasData && (
                    <div className="rpt-card">
                        {/* Tabs + search toolbar */}
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3">
                            <div className="rpt-tabs">
                                <button
                                    className={`rpt-tab${Mode === 1 ? ' active' : ''}`}
                                    onClick={() => this.setState({ Mode: 1, Totals: this.getTotals(this.state.BodyFilter) })}
                                >
                                    Item List
                                </button>
                                <button
                                    className={`rpt-tab${Mode === 2 ? ' active' : ''}`}
                                    onClick={() => this.setState({ Mode: 2, Totals: this.getTotals(this.state.BodyFilterCustomer) })}
                                >
                                    Customer List
                                </button>
                            </div>
                            <div className="rpt-search-wrap" style={{ maxWidth: 340, flex: 1 }}>
                                <AiOutlineSearch />
                                <input
                                    type="text"
                                    autoComplete="off"
                                    className="rpt-search"
                                    placeholder={Mode === 1 ? 'Search by item code, line, description…' : 'Search by customer no, name…'}
                                    onChange={Mode === 1 ? this.searchShorts : this.searchShorts2}
                                />
                            </div>
                        </div>

                        {/* Table */}
                        {Mode === 1 ? (
                            <div className="rpt-table-wrapper">
                                <table className="rpt-table">
                                    <thead>
                                        <tr className="table-blue-header">
                                            {this.state.HeaderTable.Row1.map((col, i) => (
                                                <th className={'text-center ' + ((i + 1) % 2 === 1 ? 'table-blue-header' : 'tableAquaeHeader')} key={i} colSpan={col.span}>{col.year}</th>
                                            ))}
                                        </tr>
                                        <tr className="table-blue-header">
                                            <th className="table-blue-header" colSpan={6}></th>
                                            {this.state.HeaderTable.Row2.map((col, i) => (
                                                <th className={'text-center ' + ((i + 1) % 2 === 1 ? 'table-black-header' : 'table-aqua-header')} key={i} colSpan={3}>{col.month}</th>
                                            ))}
                                        </tr>
                                        <tr className="table-blue-header">
                                            {this.state.HeaderTable.Row3.map((col, c) => (
                                                col.title.map((tit, t) => (
                                                    <th
                                                        onClick={() => this.OrderPriceMargins(tit, col)}
                                                        className={'text-center ' + (col.month === '' ? 'table-blue-header' : Number(c) % 2 === 1 ? 'table-black-header' : 'table-aqua-header')}
                                                        key={t}
                                                    >
                                                        {tit}
                                                        {tit !== '' && <span className="rpt-sort-arrows"><BsFileArrowUpFill /><BsFileArrowDownFill /></span>}
                                                    </th>
                                                ))
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.BodyFilter.map((element, e) => (
                                            <tr onClick={() => this.DetailofShort(element)} key={uuidv4()}>
                                                <td className="text-center">{e + 1}</td>
                                                <td className="text-center">{element.ItemCode}</td>
                                                <td className="text-center">{element.ProductLine}</td>
                                                <td>{element.ItemCodeDesc}</td>
                                                <td className="text-center">{element.Category}</td>
                                                <td className="text-center">{element.Subcategory}</td>
                                                {element.Detail.map((year) => (
                                                    year.Months.map((month) => (
                                                        month.shorts === '-' ? (
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className="text-center">-</td>
                                                                <td></td>
                                                                <td className="text-center">-</td>
                                                            </React.Fragment>
                                                        ) : (
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className="text-center">{month.QuantityShipped}</td>
                                                                <td className="text-end">{month.dolar}</td>
                                                                <td className="text-end">{NumberFormat(pricesFormat(month.shorts))}</td>
                                                            </React.Fragment>
                                                        )
                                                    ))
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>TOTALS</td>
                                            <td></td>
                                            <td></td>
                                            {this.state.Totals.map((total, t) => (
                                                <td className={t === 0 ? 'text-center' : 'text-end'} key={t}>{total}</td>
                                            ))}
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        ) : (
                            <div className="rpt-table-wrapper">
                                <table className="rpt-table">
                                    <thead>
                                        <tr className="table-blue-header">
                                            {this.state.HeaderTable2.Row1.map((col, i) => (
                                                <th className={'text-center ' + ((i + 1) % 2 === 1 ? 'table-blue-header' : 'table-aqua-header')} key={i} colSpan={col.span}>{col.year}</th>
                                            ))}
                                        </tr>
                                        <tr className="table-blue-header">
                                            <th className="table-blue-header" colSpan={9}></th>
                                            {this.state.HeaderTable2.Row2.map((col, i) => (
                                                <th className={'text-center ' + ((i + 1) % 2 === 1 ? 'table-black-header' : 'table-aqua-header')} key={i} colSpan={3}>{col.month}</th>
                                            ))}
                                        </tr>
                                        <tr className="table-blue-header">
                                            {this.state.HeaderTable2.Row3.map((col, c) => (
                                                col.title.map((tit, t) => (
                                                    <th
                                                        onClick={() => this.OrderPriceMargins2(tit, col)}
                                                        className={'text-center ' + (col.month === '' ? 'table-blue-header' : Number(c) % 2 === 1 ? 'table-black-header' : 'table-aqua-header')}
                                                        key={t}
                                                    >
                                                        {tit}
                                                        {tit !== '' && <span className="rpt-sort-arrows"><BsFileArrowUpFill /><BsFileArrowDownFill /></span>}
                                                    </th>
                                                ))
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.BodyFilterCustomer.map((element, e) => (
                                            <tr onClick={() => this.DetailbyCustomer(element)} key={uuidv4()}>
                                                <td className="text-center">{e + 1}</td>
                                                <td>{element.CustomerNo}</td>
                                                <td>{element.CustomerName}</td>
                                                <td className="text-center">{element.AddressLine1}</td>
                                                <td className="text-center">{element.City}</td>
                                                <td className="text-center">{element.State}</td>
                                                <td className="text-center">{element.ZipCode}</td>
                                                {element.Detail.map((year) => (
                                                    year.Months.map((month) => (
                                                        month.shorts === '-' ? (
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className="text-center">-</td>
                                                                <td></td>
                                                                <td className="text-center">-</td>
                                                            </React.Fragment>
                                                        ) : (
                                                            <React.Fragment key={uuidv4()}>
                                                                <td className="text-center">{month.QuantityShipped}</td>
                                                                <td className="text-end">{month.dolar}</td>
                                                                <td className="text-end">{NumberFormat(pricesFormat(month.shorts))}</td>
                                                            </React.Fragment>
                                                        )
                                                    ))
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td>TOTALS</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            {this.state.Totals.map((total, t) => (
                                                <td className={t === 0 ? 'text-center' : 'text-end'} key={t}>{total}</td>
                                            ))}
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        )}
                    </div>
                )}

                {/* ── Empty state ── */}
                {!hasData && (
                    <div className="rpt-empty">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
                        </svg>
                        <p>Select a date range and click <strong>Load Data</strong> to view the report.</p>
                    </div>
                )}

                {/* ── Detail modal ── */}
                <ModalOrders
                    title={Mode === 1
                        ? 'Sales of Item: ' + this.state.currentItem.ItemCode
                        : 'Sales of Customer: ' + this.state.currentCustomer.CustomerName}
                    show={this.state.showModal1}
                    close={(modal = "showModal1") => this.handleModalClose(modal)}
                >
                    {Mode === 1 ? (
                        <div className="col-12">
                            <div className="row d-flex justify-content-center">
                                <div className="col-sm-6 col-lg-6">
                                    <div className="row">
                                        <div className="col-12 pt-2 text-center d-lg-flex justify-content-lg-end align-items-center">
                                            <div className="ItemImg">
                                                <img key={this.state.currentItem.itemURL} className="pb-5 pt-5" id="ShortsProductImg"
                                                    src={this.state.currentItem.itemURL !== '' ? this.state.currentItem.itemURL : '/assets/notavailable.png'}
                                                    alt="ProductImg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-6">
                                    <div className="row pt-5">
                                        <div className="col-12 TitleText mt-4 mb-2">
                                            <span className="badge bg-primary me-4">{this.state.currentItem.ItemCode}</span>
                                            <span className="badge bg-secondary">{this.state.currentItem.ProductLine}</span>
                                        </div>
                                        <div className="col-12 TitleText">
                                            <p>{this.state.currentItem.ItemCodeDesc}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4 py-4">
                                    <ExcelDocument
                                        archname={'Sales Item ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')}
                                        sheetname={'Shorts Item ' + DeleteCharactersNotAccepted(this.state.currentItem.ItemCode) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')}
                                        data={getDataSet(this.state.ShortDetailWithTotal,
                                            ['Sales Order No', 'Invoice No', 'Customer No', 'Customer Name', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Cost', 'Total Sales($)'],
                                            ['SalesOrderNo', 'InvoiceNo', 'CustomerNo', 'BillToName', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPriceD', 'TotalShortD']
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="row pt-2">
                                <div className="col-12 tableFixHead">
                                    <table className="table table-hover">
                                        <thead className="table-dark">
                                            <tr className="text-center">
                                                <th>Sales Order No</th><th>Invoice No</th><th>Type</th>
                                                <th>Customer No</th><th>Customer Name</th><th>Price Level</th>
                                                <th>Sales Person</th><th>Route</th><th>Date</th>
                                                <th>Qty Ordered</th><th>Qty Shipped</th>
                                                <th>Category</th><th>Subcategory</th>
                                                <th>Unit Cost</th><th>Unit Price</th><th>Total Sales</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.ShortDetail.map((item, i) => (
                                                <tr key={i}>
                                                    <td className="text-center">{item.SalesOrderNo}</td>
                                                    <td className="text-center">{item.InvoiceNo}</td>
                                                    <td className="text-center">{item.InvoiceType}</td>
                                                    <td className="text-center">{item.CustomerNo}</td>
                                                    <td>{item.BillToName}</td>
                                                    <td className="text-center">{item.PriceLevel}</td>
                                                    <td className="text-center">{item.SalespersonNo}</td>
                                                    <td>{item.UDF_RUTA}</td>
                                                    <td className="text-center">{new Date(item.InvoiceDate).toLocaleDateString('en-US')}</td>
                                                    <td className="text-center">{NumberFormat(item.QuantityOrdered)}</td>
                                                    <td className="text-center">{NumberFormat(item.QuantityShipped)}</td>
                                                    <td className="text-center">{item.Category}</td>
                                                    <td className="text-center">{item.Subcategory}</td>
                                                    <td className="text-center">{NumberFormat(item.UnitCost)}</td>
                                                    <td className="text-center">$ {NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                                    <td className="text-center">$ {NumberFormat(pricesFormat(item.shorts))}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="bg-secondary text-light">
                                                <td colSpan={7}></td>
                                                <td className="text-center">TOTAL</td>
                                                <td className="text-center">{NumberFormat(pricesFormat(this.state.currentItem.totalQuantityOrdered))}</td>
                                                <td className="text-center">{NumberFormat(pricesFormat(this.state.currentItem.totalQuantityShipped))}</td>
                                                <td colSpan={3}></td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{NumberFormat(pricesFormat(this.state.currentItem.totalShorts))}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="row d-flex justify-content-center">
                                <div className="col-12 my-3">
                                    <div className="row">
                                        <div className="col-6 titleTotal text-end"><p>Customer No:</p></div>
                                        <div className="col-6 TitleText"><p>{this.state.currentCustomer.CustomerNo}</p></div>
                                        <div className="col-6 titleTotal text-end"><p>Customer Name:</p></div>
                                        <div className="col-6 TitleText"><p>{this.state.currentCustomer.CustomerName}</p></div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-lg-4 py-4">
                                    <ExcelDocument
                                        archname={'Sales Customer ' + DeleteCharactersNotAccepted(this.state.currentCustomer.CustomerName) + ' ' + getDateFromReports() + ' ' + getValueCookie('Company')}
                                        sheetname={'Sales ' + DeleteCharactersNotAccepted(this.state.currentCustomer.CustomerName)}
                                        data={getDataSet(this.state.ShortDetailWithTotal,
                                            ['Sales Order No', 'Invoice No', 'Item Code', 'Description', 'Price Level', 'Sales Person', 'Route', 'Date', 'Quantity Ordered', 'Quantity Shipped', 'Unit Cost', 'Total Sales($)'],
                                            ['SalesOrderNo', 'InvoiceNo', 'ItemCode', 'ItemCodeDesc', 'PriceLevel', 'SalespersonNo', 'UDF_RUTA', 'InvoiceDate', 'QuantityOrdered', 'QuantityShipped', 'UnitPriceD', 'TotalShortD']
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="row pt-2">
                                <div className="col-12 tableFixHead">
                                    <table className="table table-hover">
                                        <thead className="table-dark">
                                            <tr className="text-center">
                                                <th>Sales Order No</th><th>Invoice No</th><th>Type</th>
                                                <th>Item Code</th><th>Description</th><th>Price Level</th>
                                                <th>Sales Person</th><th>Route</th><th>Date</th>
                                                <th>Qty Ordered</th><th>Qty Shipped</th>
                                                <th></th><th>Unit Price</th><th></th><th>Total Sales($)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.CustomerDetail.map((item, i) => (
                                                <tr key={i}>
                                                    <td className="text-center">{item.SalesOrderNo}</td>
                                                    <td className="text-center">{item.InvoiceNo}</td>
                                                    <td className="text-center">{item.InvoiceType}</td>
                                                    <td className="text-center">{item.ItemCode}</td>
                                                    <td>{item.ItemCodeDesc}</td>
                                                    <td className="text-center">{item.PriceLevel}</td>
                                                    <td className="text-center">{item.SalespersonNo}</td>
                                                    <td>{item.UDF_RUTA}</td>
                                                    <td className="text-center">{DateFormatMAS90(item.InvoiceDate)}</td>
                                                    <td className="text-center">{NumberFormat(item.QuantityOrdered)}</td>
                                                    <td className="text-center">{NumberFormat(item.QuantityShipped)}</td>
                                                    <td className="text-end">$</td>
                                                    <td className="text-end">{NumberFormat(pricesFormat(item.UnitPrice))}</td>
                                                    <td className="text-end">$</td>
                                                    <td className="text-end">{NumberFormat(pricesFormat(item.shorts))}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr className="bg-secondary text-light">
                                                <td colSpan={7}></td>
                                                <td className="text-center">TOTAL</td>
                                                <td className="text-center">{NumberFormat(pricesFormat(this.state.currentCustomer.totalQuantityOrdered))}</td>
                                                <td className="text-center">{NumberFormat(pricesFormat(this.state.currentCustomer.totalQuantityShipped))}</td>
                                                <td></td>
                                                <td className="text-end">$</td>
                                                <td className="text-end">{NumberFormat(pricesFormat(this.state.currentCustomer.totalShorts))}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}
                </ModalOrders>
            </div>
        )
    }
}
